import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import InfoArrFunc from "./info_arr_func";

class PageFunc {
  static data: any = {};
  static list = (inOptObj: any) => {
    let this_obj = this;
    let tmp_list_opt = { ...this_obj.data.listOpt, ...inOptObj };
    this_obj.data.setListOpt(tmp_list_opt);
    let tmp_listOpt = { ...tmp_list_opt };

    tmp_listOpt["s_addon_home_work_file_start_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_home_work_file_end_date"] = tmp_listOpt["s_addon_todo_end_date"];
    tmp_listOpt["s_addon_plan_study_file_start_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_plan_study_file_end_date"] = tmp_listOpt["s_addon_todo_end_date"];
    tmp_listOpt["s_addon_attend_start_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_attend_end_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_attend_start_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_attend_end_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_todo_dailyc_start_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_todo_dailyc_end_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_daily_report_start_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_daily_report_end_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_desk_use_start_date"] = tmp_listOpt["s_addon_todo_start_date"];
    tmp_listOpt["s_addon_desk_use_end_date"] = tmp_listOpt["s_addon_todo_start_date"];

    //하루전꺼부터 조회
    let tmp_start_date = tmp_listOpt["s_addon_todo_start_date"];
    let tmp_start_date_json = DateFunc.get_date_json(new Date(tmp_start_date));
    let pre_date_change_num = -1;
    if (tmp_start_date_json.day == 1) {
      //일요일이면 3일뒤로이동(금요일부터 보이게한다.)
      pre_date_change_num = -3;
    }
    let pre_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', pre_date_change_num), "Y-m-d");
    tmp_listOpt["s_addon_todo_start_date"] = pre_date_str;
    tmp_listOpt["s_addon_home_work_file_start_date"] = pre_date_str;

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', tmp_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let info_arr = InfoArrFunc.get_info_arr_by_filter({
            info_arr: response.data["data"]["info_arr"],
            list_opt: tmp_listOpt,
            base_date_str: tmp_listOpt["s_addon_todo_end_date"],
            pre_date_str: pre_date_str,
            is_only_now_desk: this_obj.data.is_only_now_desk,
          });

          this_obj.data.setInfoArr(info_arr);
          this_obj.data.setCountInfo({ "tot": info_arr.length });
          if (response.data["data"]["now_ymdhis"]) {
            this_obj.data.set_now_ymdhis(response.data["data"]["now_ymdhis"]);
          }
        } else {

        }
      });
  };
  static get_stu_arr_by_checked = (inData: any) => {
    let this_obj = this;
    let opt_obj = {
      infoArr: this_obj.data.infoArr,
      check_row_val_arr: this_obj.data.check_row_val_arr,
      ...inData
    };
    let checked_stu_seq_arr: any = [];
    for (let i = 0; i < opt_obj.check_row_val_arr.length; i++) {
      let checked_val = opt_obj.check_row_val_arr[i];
      let checked_stu_seq = checked_val.split(",")[0];
      if (strFunc.str_in_array(checked_stu_seq, checked_stu_seq_arr) == -1) {
        checked_stu_seq_arr.push(checked_stu_seq);
      }
    }
    let select_stu_info_arr: any = [];
    for (let i = 0; i < opt_obj.infoArr.length; i++) {
      let info = opt_obj.infoArr[i];
      if (strFunc.str_in_array(info["a_seq"], checked_stu_seq_arr) != -1) {
        select_stu_info_arr.push(info);
      }
    }
    return select_stu_info_arr;
  };
  static openTodoDaySort = (inData: any) => {
    let this_obj = this;
    let opt_obj = {
      select_stu_name: "",
      select_stu_seq: "",
      select_date: this_obj.data.listOpt.s_addon_todo_start_date,
      subject_name: "",
      ...inData
    };
    this_obj.data.setPopupData({
      ...this_obj.data.popupData,
      isOpen: true,
      has_header: true,
      sort: "todo_day_sort",
      title: "",
      width: "600px",
      height: "100%",
      ...opt_obj
    });
  };
  static openSendSmsPopup = () => {
    let this_obj = this;
    let receive_arr: any = [];
    let select_stu_info_arr = this_obj.get_stu_arr_by_checked({});

    for (let i = 0; i < select_stu_info_arr.length; i++) {
      let u_info: any = select_stu_info_arr[i];
      let row_is_add_stu_phone = false;
      let row_is_add_parent_phone = false;
      if (this_obj.data.sms_phone_check == "student") {
        row_is_add_stu_phone = true;
      } else if (this_obj.data.sms_phone_check == "parent") {
        row_is_add_parent_phone = true;
      } else if (this_obj.data.sms_phone_check == "both") {
        row_is_add_stu_phone = true;
        row_is_add_parent_phone = true;
      }
      if (row_is_add_stu_phone) {
        receive_arr.push({
          phone_num: u_info["a_user_phone"],
          user_name: u_info["a_user_name"],
          user_seq: u_info["a_seq"]
        });
      }
      if (row_is_add_parent_phone) {
        if (u_info.link_user_arr && u_info.link_user_arr[0] && u_info.link_user_arr[0]["par_info"]) {
          let tmp_line_len = u_info.link_user_arr.length;
          for (let j = 0; j < tmp_line_len; j++) {
            let par_info = u_info.link_user_arr[j]["par_info"];
            receive_arr.push({
              "user_seq": par_info.a_seq,
              "phone_num": strFunc.autoHypenPhone(par_info.a_user_phone),
              "user_name": par_info.a_user_name
            });
          }
        }
      }

    }

    if (receive_arr.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }

    this_obj.data.setPopupData({
      ...this_obj.data.popupData,
      isOpen: true,
      has_header: true,
      sort: "send_sms",
      title: "문자전송",
      receive_arr: receive_arr,
      width: "900px",
      height: "90%",
    });
  };
  static deleteAttend = (dataArr: any, confirm_msg: string) => {
    let this_obj = this;
    if (!confirm(confirm_msg)) {
      return false;
    }
    let del_form_data = {
      "data_arr": dataArr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/attend/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          this_obj.list({});
        } else {

        }
      });
  };

  static openAttendPopup = (selected_row: [], attend_sort: string, attend_sort_detail: string) => {
    let this_obj = this;
    let pop_title = "등원";
    if (attend_sort == "out") {
      pop_title = "하원";
    }
    if (this_obj.data.xColumnArr.select_arr.a_sort_detail) {
      for (let i = 0; i < this_obj.data.xColumnArr.select_arr.a_sort_detail.length; i++) {
        let item = this_obj.data.xColumnArr.select_arr.a_sort_detail[i];
        if (item.value == attend_sort_detail) {
          pop_title = item.text;
        }
      }
    }

    if (selected_row.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    let attend_date = this_obj.data.listOpt.s_addon_attend_start_date;
    this_obj.data.setPopupData({
      ...this_obj.data.popupData,
      "isOpen": true,
      has_header: true,
      sort: "add_attend",
      "title": pop_title,
      attend_sort: attend_sort,
      attend_sort_detail: attend_sort_detail,
      select_date: attend_date,
      user_info_arr: selected_row,
      width: "600px",
      height: "100%",
    });
  };

  static openAttendBySelect = (attend_sort: string, attend_sort_detail: string) => {
    let this_obj = this;
    let selected_rows: any = PageFunc.get_stu_arr_by_checked({});
    this_obj.openAttendPopup(selected_rows, attend_sort, attend_sort_detail);
  };

  static openTodoWriteOnePopup = (inData: any) => {
    let this_obj = this;
    let opt_obj = {
      select_date: "",
      select_stu_name: "",
      select_stu_seq: "",
      todo_info: {},
      todo_sort: "study",
      isUpdate: true,
      ...inData
    };
    if (opt_obj["isUpdate"]) {
      if (strFunc.is_empty(opt_obj["todo_info"]["a_seq"])) {
        alert("내용 없음.");
        return false;
      }
    }
    this_obj.data.setPopupData({
      ...this_obj.data.popupData,
      isOpen: true,
      has_header: true,
      sort: "todo_write_one",
      select_stu_name: opt_obj["select_stu_name"],
      select_stu_seq: opt_obj["select_stu_seq"],
      select_date: opt_obj["select_date"],
      todo_sort: opt_obj["todo_sort"],
      todo_info: opt_obj["todo_info"],
      isUpdate: opt_obj["isUpdate"],
      title: "맞춤플랜",
      width: "600px",
      height: "100%",
      ...opt_obj
    });
  };

  static show_detail_view = (info_idx: number) => {
    let this_obj = this;
    if (info_idx < 0) {
      info_idx = 0;
    }
    if (info_idx >= this_obj.data.infoArr.length) {
      info_idx = this_obj.data.infoArr.length - 1;
    }

    this_obj.data.setPopupData({
      ...this_obj.data.popupData,
      "isOpen": true,
      "title": "원생관리",
      "sort": "stu_view",
      write_page_data: {
        is_show: true,
        is_update: true,
        is_view_mode: true,
        is_view_basic: false,
        select_idx: info_idx,
        info_arr: this_obj.data.infoArr,
        default_write_info: {},
      },
      width: "98%",
      height: "99%",
      has_header: false,
    });

    //set_select_idx(info_idx);
    //set_is_detail_view(true);
  };
  static close_detail_view = () => {
    let this_obj = this;
    this_obj.list({});
    this_obj.data.set_is_detail_view(false);
  };

  static get_subject_stu_seq_by_checked = (inData: any) => {
    let this_obj = this;
    let opt_obj = {
      check_row_val_arr: this_obj.data.check_row_val_arr,
      ...inData
    };
    let rs_data: any = {
      subject_name: "",
      select_subejct_name_arr: [],
      select_stu_seq_arr: [],
    };
    for (let i = 0; i < opt_obj.check_row_val_arr.length; i++) {
      let checked_val: any = opt_obj.check_row_val_arr[i];
      let checked_stu_seq = checked_val.split(",")[0];
      let checked_subject_name = "";
      if (checked_val.split(",").length >= 2) {
        checked_subject_name = checked_val.split(",")[1];
      }
      if (strFunc.str_in_array(checked_stu_seq, rs_data.select_stu_seq_arr) == -1) {
        rs_data.select_stu_seq_arr.push(checked_stu_seq);
      }
      if (!strFunc.is_empty(checked_subject_name)) {
        if (strFunc.str_in_array(checked_subject_name, rs_data.select_subejct_name_arr) == -1) {
          rs_data.select_subejct_name_arr.push(checked_subject_name);
        }
      }
    }
    if (rs_data.select_subejct_name_arr.length > 0) {
      rs_data.subject_name = rs_data.select_subejct_name_arr[0];
    }

    return rs_data;
  };

  static openTodoDailyCWritePopup = (inData: any) => {
    let this_obj = this;
    let opt_obj = {
      select_date: this_obj.data.listOpt.s_addon_todo_start_date,
      check_row_val_arr: this_obj.data.check_row_val_arr,
      todo_dailyc_sort: "complete",
      ...inData
    };

    let subject_stu_seq_data = this_obj.get_subject_stu_seq_by_checked(opt_obj);
    let subject_name = subject_stu_seq_data.subject_name;
    let select_subejct_name_arr: any = subject_stu_seq_data.select_subejct_name_arr;
    let select_stu_seq_arr: any = subject_stu_seq_data.select_stu_seq_arr;
    if (select_subejct_name_arr.length == 0) {
      alert("과목이 없습니다.");
      return false;
    }
    if (select_subejct_name_arr.length != 1) {
      alert("과목은 한개만 선택해주세요.");
      return false;
    }
    if (select_stu_seq_arr.length == 0) {
      alert("선택 학생이 없습니다.");
      return false;
    }

    this_obj.data.setPopupData({
      ...this_obj.data.popupData,
      isOpen: true,
      has_header: true,
      sort: "todo_dailyc_write",
      select_date: opt_obj["select_date"],
      subject_name: subject_name,
      select_stu_seq_arr: select_stu_seq_arr,
      todo_dailyc_sort: opt_obj.todo_dailyc_sort,
      title: "맞춤플랜",
      width: "600px",
      height: "100%",
      ...opt_obj
    });
  };
  static go_todo_dailyc_write = (inData: any) => {
    let this_obj = this;
    let opt_obj = {
      select_date: this_obj.data.listOpt.s_addon_todo_start_date,
      check_row_val_arr: this_obj.data.check_row_val_arr,
      todo_dailyc_sort: "complete",
      a_memo: "",
      ...inData
    };

    let subject_stu_seq_data = this_obj.get_subject_stu_seq_by_checked(opt_obj);
    let subject_name = subject_stu_seq_data.subject_name;
    let select_subejct_name_arr: any = subject_stu_seq_data.select_subejct_name_arr;
    let select_stu_seq_arr: any = subject_stu_seq_data.select_stu_seq_arr;
    let stu_info_arr = this_obj.get_stu_arr_by_checked({
      check_row_val_arr: opt_obj.check_row_val_arr
    });

    if (strFunc.is_empty(opt_obj.select_date)) {
      alert("날짜를 선택하세요.");
      return false;
    }
    if (select_subejct_name_arr.length >= 2) {
      alert("과목은 한개만 선택해주세요.");
      return false;
    }
    if (strFunc.is_empty(subject_name)) {
      alert("과목을 선택하세요.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.todo_dailyc_sort)) {
      alert("구분을 선택하세요.");
      return false;
    }
    if (stu_info_arr.length == 0) {
      alert("학생을 선택하세요.");
      return false;
    }
    if (!confirm("완료 하시겠습니까?")) {
      return false;
    }

    let todo_dailyc_data = {
      a_date: opt_obj.select_date,
      a_subject: subject_name,
      a_stu_seq: "",
      a_sort: opt_obj.todo_dailyc_sort,
      a_memo: opt_obj.a_memo,
      a_writer_seq: this_obj.data.user.user_seq,
      a_writer: this_obj.data.user.user_name,
    };

    let write_todo_dailyc_arr: any = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      let stu_info = stu_info_arr[i];
      let stu_seq = stu_info["a_seq"];
      let stu_name = stu_info["user_name"];
      let todo_dailyc_data_obj = {
        ...todo_dailyc_data,
        a_stu_seq: stu_seq,
        a_stu_name: stu_name,
        a_writer_seq: this_obj.data.user.user_seq,
        a_writer: this_obj.data.user.user_name,
      };
      write_todo_dailyc_arr.push(todo_dailyc_data_obj);
    }
    let form_json_data = {
      "data_arr": write_todo_dailyc_arr,
      "is_auto_add_star": "1",
      "is_desk_end": "1",
      "is_default_val": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo_dailyc/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          this_obj.data.set_loading_data({
            is_display: true,
            text: "완료 되었습니다.",
          });
          setTimeout(() => {
            this_obj.data.set_loading_data({
              ...this_obj.data.loading_data,
              is_display: false,
            });
          }, 600);
          this_obj.update_io_of_todoc({
            todo_dailyc_arr: response.data["data"],
          });
          if (response.data["end_desk_use_arr"] && response.data["end_desk_use_arr"].length > 0) {
            this_obj.update_io_of_desk_use_arr({
              desk_use_arr: response.data["end_desk_use_arr"],
            });
          }
          setTimeout(()=>{
            this_obj.list({});
          },500);
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  static update_io_of_desk_use_arr = (inData: any) => {
    let this_obj = this;
    let opt_obj = {
      desk_use_arr: [],
      detail: "update",//delete
      ...inData
    };

    if (this_obj.data.data_io_ref.current && opt_obj.desk_use_arr) {
      this_obj.data.data_io_ref.current.send({
        sort: "desk_use_arr",
        detail: opt_obj.detail,
        desk_use_arr: opt_obj.desk_use_arr,
        select_date: this_obj.data.listOpt.s_addon_todo_start_date,
      });
    }
  };
  static update_io_of_todoc = (inData: any) => {
    let this_obj = this;
    let opt_obj = {
      todo_dailyc_arr: [],
      detail: "update",//delete
      ...inData
    };

    if (this_obj.data.data_io_ref.current && opt_obj.todo_dailyc_arr) {
      this_obj.data.data_io_ref.current.send({
        sort: "todo_dailyc_arr",
        detail: opt_obj.detail,
        todo_dailyc_arr: opt_obj.todo_dailyc_arr,
        select_date: this_obj.data.listOpt.s_addon_todo_start_date,
      });
    }
  };
}
export default PageFunc;